/**
 * Cascade-policy shapes (Phase B.3 §4.6 admin policy).
 *
 * The response is the contract's CascadepolicyPolicyResponse, generated into
 * policy.generated.ts by make docs; this module never restates it.
 *
 * The vocabulary:
 *   - `cascade_order` — admin's preferred order (subset, ordered)
 *   - `default_order` — fallback order (returned for reference)
 *   - `final_order`   — what loginflow uses (composed)
 *
 * Only three methods are reorderable: passkey (always first)
 * and admin_recovery (always last) are NOT part of the
 * vocabulary — both are pinned by schema CHECK constraints.
 */

import { z } from "zod";

import { cascadePolicySchema } from "./policy.generated";

export { cascadePolicySchema };
export type CascadePolicy = z.infer<typeof cascadePolicySchema>;

export const cascadeMethodSchema = cascadePolicySchema.shape.cascade_order.element;
export type CascadeMethod = z.infer<typeof cascadeMethodSchema>;

export const setCascadePolicyRequestSchema = z.object({
  cascade_order: z.array(cascadeMethodSchema),
});
export type SetCascadePolicyRequest = z.infer<typeof setCascadePolicyRequestSchema>;

// ── Human-readable labels ─────────────────────────────────────
// Plain words only: the protocol names (TOTP, RFC 6238) stay out of the UI.

export const CASCADE_METHOD_LABELS: Record<CascadeMethod, string> = {
  totp: "Authenticator app",
  recovery_code: "Recovery codes",
  recovery_email: "Recovery email",
};

export const CASCADE_METHOD_DESCRIPTIONS: Record<CascadeMethod, string> = {
  totp: "Codes from 1Password, Authy or Google Authenticator.",
  recovery_code: "Single-use codes the person saved during setup.",
  recovery_email: "A 6-digit code sent to their recovery email.",
};
